import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ae3bc158"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-row justify-between items-center" };
const _hoisted_2 = { class: "flex flex-row items-center" };
const _hoisted_3 = { class: "addGuestIcon" };
const _hoisted_4 = { class: "text-gray-900" };
const _hoisted_5 = { class: "addGuestsBody" };
const _hoisted_6 = { class: "addLabel" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-l-[0.2px] border-gray-200 h-auto my-[20px]" }, null, -1 /* HOISTED */));
const _hoisted_8 = { class: "listGuestsContainer" };
const _hoisted_9 = ["id"];
const _hoisted_10 = { class: "flex flex-row items-center w-3/4" };
const _hoisted_11 = { class: "flex w-[87%] flex-col leading-3 ml-3" };
const _hoisted_12 = {
    key: 0,
    class: "text-sm font-medium leading-5",
    id: "add-guests-guest-details-container-name"
};
const _hoisted_13 = {
    class: "text-sm font-normal leading-5",
    id: "add-guests-guest-details-container-email"
};
const _hoisted_14 = ["id", "onClick"];
const _hoisted_15 = { class: "addGuestsFooter" };
import { User01Icon, UsersPlusIcon, XCloseIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIAvatar, UIButton, UIModal } from '@gohighlevel/ghl-ui';
import SearchContacts from './SearchContacts.vue';
import { appointmentWizardState } from './appointmentWizardState';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AddGuest',
    props: {
        showModal: Boolean,
        onClickClose: Function,
    },
    setup(__props) {
        // Function to remove a guest based on its index in guestsRef
        const removeGuest = (index) => {
            var _a;
            // Use splice to remove the guest at the specified index from guestsRef
            (_a = appointmentWizardState.guestsRef) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: __props.showModal,
                width: _unref(appointmentWizardState).width
            }, {
                header: _withCtx(() => [
                    _createCommentVNode(" Header section with guest addition title and close button "),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createCommentVNode(" Add guest icon "),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_unref(UsersPlusIcon), { class: "w-5 h-5 text-gray-700" })
                            ]),
                            _createCommentVNode(" Guest addition title "),
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('addGuests.add_guest_appointment')), 1 /* TEXT */)
                        ]),
                        _createCommentVNode(" Close icon to close the modal "),
                        _createVNode(_unref(XCloseIcon), {
                            id: "add-guests-close-button",
                            class: "w-5 h-5 text-gray-500 cursor-pointer",
                            onClick: _cache[0] || (_cache[0] = ($event) => (__props.onClickClose()))
                        })
                    ])
                ]),
                footer: _withCtx(() => [
                    _createCommentVNode(" Footer buttons for canceling and completing the addition of guests "),
                    _createElementVNode("div", _hoisted_15, [
                        _createVNode(_unref(UIButton), {
                            id: "add-guest-cancel-button",
                            type: "default",
                            onClick: _cache[1] || (_cache[1] = ($event) => (__props.onClickClose()))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_unref(UIButton), {
                            id: "add-guest-done-button",
                            type: "primary",
                            onClick: _cache[2] || (_cache[2] = ($event) => (__props.onClickClose()))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('common.done')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_5, [
                        _createCommentVNode(" Label for adding guests "),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('addGuests.search_add_guest')), 1 /* TEXT */),
                        _createCommentVNode(" Select input for adding guests "),
                        _createVNode(SearchContacts, {
                            "is-add-contact": false,
                            screen: "add-guest"
                        }),
                        _hoisted_7,
                        _createCommentVNode(" Display added guests "),
                        _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(appointmentWizardState).guestsRef, (value, i) => {
                                return (_openBlock(), _createElementBlock("div", { key: i }, [
                                    (value != null)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            id: 'add-guests-guest-details-container-' + value.id,
                                            key: value.id,
                                            class: "flex w-full cursor-pointer items-center mb-[20px] justify-between"
                                        }, [
                                            _createCommentVNode(" Left part: Avatar and Contact Details "),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createCommentVNode(" Display guest's avatar or default avatar "),
                                                (value.initials)
                                                    ? (_openBlock(), _createBlock(_unref(UIAvatar), {
                                                        key: 0,
                                                        style: _normalizeStyle({
                                                            color: 'var(--gray-600)',
                                                            backgroundColor: 'var(--gray-100)',
                                                        })
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(value.initials), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["style"]))
                                                    : (_openBlock(), _createBlock(_unref(UIAvatar), {
                                                        key: 1,
                                                        class: "bg-gray-100 mr-2"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(User01Icon), { class: "w-5 h-5 text-gray-700" })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    })),
                                                _createElementVNode("div", _hoisted_11, [
                                                    _createCommentVNode(" Display guest's name "),
                                                    (value.name)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(value.name), 1 /* TEXT */))
                                                        : _createCommentVNode("v-if", true),
                                                    _createCommentVNode(" Display guest's email "),
                                                    _createElementVNode("div", _hoisted_13, _toDisplayString(value.email), 1 /* TEXT */)
                                                ])
                                            ]),
                                            _createCommentVNode(" Remove guest button "),
                                            _createElementVNode("div", {
                                                id: 'add-guests-guest-details-container-remove-contact-' + value.id,
                                                class: "text-error-700 font-semibold cursor-pointer",
                                                onClick: ($event) => (removeGuest(i))
                                            }, _toDisplayString(_ctx.$t('common.remove')), 9 /* TEXT, PROPS */, _hoisted_14)
                                        ], 8 /* PROPS */, _hoisted_9))
                                        : _createCommentVNode("v-if", true)
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show", "width"]));
        };
    }
});
